module.exports = __webpack_public_path__ + "img/logo.ee7b2e83.png";